import { Box, Title, Text } from "@mantine/core";
import { PDFTitleSvg } from "../../../shared/svg";
import { PDFPage } from "./PDFPage";
import useProfileStore from "../../../store/useProfileStore";
import { useTranslation } from "react-i18next";
import useAuthStore from "../../../store/useAuthStore";

export const PDFTitle = () => {
  const { profile } = useProfileStore();
  const { t } = useTranslation();
  const { user } = useAuthStore();

  const username =
    profile?.user.first_name && profile?.user.last_name
      ? profile?.user.first_name + " " + profile?.user.last_name
      : user?.full_name || " ";

  return (
    <PDFPage>
      <Box bg="#000" h="100%">
        <Box ml="112px">
          <PDFTitleSvg />
        </Box>
        <Title c="#fff" size={96} ta="center">
          {t("career_opportunities")}
        </Title>
        <Text size="72px" fw="400" c="#fff" ta="center" mt={34}>
          {username}
        </Text>
      </Box>
    </PDFPage>
  );
};
